<template>
  <router-link
    v-if="visivel"
    :to="{ name: 'grupoEmpresaConsolidado' }"
    class="painel-grupo-atalho d-block"
    data-testid="atalho-painel-consolidado"
  >
    <div class="d-flex align-items-start justify-content-between">
      <div>
        <span class="painel-grupo-atalho__tag">Visão multiempresa</span>
        <strong class="painel-grupo-atalho__titulo d-block mt-2">
          Painel consolidado
        </strong>
        <small class="painel-grupo-atalho__texto d-block mt-1">
          Vendas, financeiro e saldos bancários do grupo.
        </small>
      </div>
      <span class="painel-grupo-atalho__seta">
        <i class="fas fa-arrow-right"></i>
      </span>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PainelGrupoAtalho",
  computed: {
    ...mapGetters(["currentUser", "empresaContexto", "features"]),
    visivel() {
      const admin = [true, 1, "1", "true"].includes(this.currentUser?.admin);

      return (
        admin &&
        this.empresaContexto?.tipo_grupo === "MATRIZ" &&
        Boolean(this.empresaContexto?.id_grupo_empresa) &&
        (this.features || []).includes("PLG_MULTIEMPRESA")
      );
    },
  },
};
</script>

<style scoped>
.painel-grupo-atalho {
  background: linear-gradient(135deg, var(--primary-color), #5578eb);
  border-radius: 0.65rem;
  box-shadow: 0 8px 20px rgba(54, 153, 255, 0.2);
  color: #fff;
  padding: 1.25rem;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.painel-grupo-atalho:hover {
  box-shadow: 0 12px 24px rgba(54, 153, 255, 0.28);
  color: #fff;
  transform: translateY(-2px);
}

.painel-grupo-atalho__tag {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  padding: 0.3rem 0.65rem;
  text-transform: uppercase;
}

.painel-grupo-atalho__titulo {
  color: #fff;
  font-size: 1rem;
}

.painel-grupo-atalho__texto {
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.35;
}

.painel-grupo-atalho__seta {
  align-items: center;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  display: flex;
  flex: 0 0 34px;
  height: 34px;
  justify-content: center;
  margin-left: 0.75rem;
  width: 34px;
}
</style>
